import React from 'react';

import { T8y } from 'ui';

export const Meta4 = () => {
  return (
    <div>
      <T8y as="h1" center bold mb2>
        4 Yard Skip
      </T8y>
      <T8y as="h2" center mb2>
        Small Skip - Perfect for Small Domestic Projects
      </T8y>
      <T8y as="p" center mb3>
        The 4-yard skip is an excellent choice for homeowners tackling small DIY
        projects or decluttering tasks. Compact yet spacious, it fits
        comfortably on most properties without the need for a permit, making
        waste disposal hassle-free.
      </T8y>
      <T8y as="h3" center mb2>
        Ideal Uses for a 4 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Garden waste disposal <br /> Small kitchen or bathroom refurbishments
        <br /> Clearing out garages, lofts, or sheds <br /> Disposing of old
        furniture and household items
      </T8y>
      <T8y as="h3" center mb2>
        Benefits of Hiring a 4 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Space-Saving Design: Easily fits on driveways or small spaces.
        Cost-Effective: An affordable solution for minimal waste volumes.
        Convenient Loading: Low sides allow for easy disposal of waste
        materials. Quick Delivery and Pickup: Flexible scheduling to suit your
        timeline.
      </T8y>
      <T8y as="h4" center mb2>
        How to Book a 4 Yard Skip
      </T8y>
      <T8y as="p" center mb5>
        Booking is simple - use our online platform to schedule your skip
        delivery based on your location. We offer flexible hire periods and can
        provide same-day delivery to accommodate your project's needs.
      </T8y>
    </div>
  );
};
